import { ChangeDetectorRef, Component, DestroyRef, inject, PLATFORM_ID, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormArray, Validators, FormBuilder, AbstractControl, FormControl } from '@angular/forms';
import { NativeDateAdapter, MatDateFormats } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { QuickOrderService } from 'src/app/services/feature/QuickOrder/quick-order.service';
import { KbQuickorderErrPopupComponent } from './kb-quickorder-err-popup/kb-quickorder-err-popup.component';
import { AddtocartPopupConfirmationComponent } from './addtocart-popup-confirmation/addtocart-popup-confirmation.component';
import { Observable, Subject, of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { NavigationStart, Router } from '@angular/router';
import { KBLanguageService } from 'src/app/services/sapSpartacus/kbLanguageService/KbLang-service.service';
import moment from 'moment';
import { CartTrackingService } from 'src/app/customServices/cart-tracking.service';
import { isPlatformBrowser } from '@angular/common';
export class AppDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    if (displayFormat === "input") {
      let day: string = date.getDate().toString();
      day = +day < 10 ? "0" + day : day;
      let month: string = (date.getMonth() + 1).toString();
      month = +month < 10 ? "0" + month : month;
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    }
    return date.toDateString();
  }
}
export const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: { month: "short", year: "numeric", day: "numeric" },
  },
  display: {
    dateInput: "input",
    monthYearLabel: { year: "numeric", month: "numeric" },
    dateA11yLabel: {
      year: "numeric", month: "long", day: "numeric"
    },
    monthYearA11yLabel: { year: "numeric", month: "long" },
  }
};
@Component({
  selector: 'app-kb-quickorderform',
  templateUrl: './kb-quickorderform.component.html',
  styleUrls: ['./kb-quickorderform.component.scss'],
  standalone: false
})
export class KbQuickorderformComponent {
  private unsubscribe$ = new Subject<void>();
  private destroyRef = inject(DestroyRef);
  entirePageLoad: boolean = false;
  public myForm: FormGroup;
  public topDateForm: FormGroup;
  entry: any;
  cartId;
  orderType;
  orderTypeSelected: boolean = true;
  orderTypeNotSelected: boolean = false;
  isOrderTypeVORDisableDates: boolean = false;
  datesRevised: boolean = false;
  disableAddToCart = signal<boolean>(true);
  productName: string = '';
  minRows: number = 3;
  maxRows: number = 3;
  getProdInfo: any;
  requestedDeliveryDate;
  selectedDates: Date[] = [];
  isselectAllcheckBoxes: boolean = false;
  dateError: boolean = false;
  isMobile: boolean = false;
  hasUnsavedChanges: boolean = true;
  invalidDate: boolean = false;
  isPastDate: boolean = false;
  isWeekendDate: boolean = false;
  invalidDatebot: boolean[] = [false];
  isPastDatebot: boolean[] = [false];
  isWeekendDatebot: boolean[] = [false];
  todayDate: Date = new Date();
  bsDate: Date;
  dateFormat: string = 'DD.MM.YYYY';
  maxCallStackBugPatchFix: boolean = false;
  initialPageLoadcall: boolean = false;
  currentLang = '';
  toClearDate: Date | null = null;
  lastDate: any;
  lastDateBot = [];
  weekendsDatesFilter = (d: Date): boolean => {
    const day = d?.getDay();
    /* Prevent Saturday and Sunday for select. */
    return day !== 0 && day !== 6;
  }
  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID
  platformId = inject(PLATFORM_ID);
  currentB2bUnitSendToWebtrack !: string;
  constructor(private fb: FormBuilder,
    private service: QuickOrderService,
    private Activecart: ActiveCartFacade,
    public cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private activeCart: ActiveCartFacade,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private kbLangService: KBLanguageService,
    private cartTrackingService: CartTrackingService) {
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.unsubscribe$))
      .subscribe(result => {
        this.isMobile = result.matches;
      });
    this.topDateForm = this.fb.group({
      topdate: [null],
    });
    this.initialGetApi();
  }
  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.currentLang = window.localStorage.getItem('spartacus⚿⚿language');
    }
    this.bsDate = this.todayDate;
    this.myForm?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.updateAddToCartState());

  }
  ngAfterViewInit() {
    this.kbLangService.getActive().pipe(takeUntil(this.unsubscribe$)).subscribe((lang: any) => {
      if (this.initialPageLoadcall) {
        this.resetForm();
      }
    });
  }
  canDeactivate(): Observable<boolean> {
    if (isPlatformBrowser(this.platformId)) {
      if (!this.hasUnsavedChanges) {
        const result = window.confirm('There are unsaved changes! Are   you sure?');
        return of(result);
      }
    }
    return of(true);
  }
  onSubmit() {
    this.hasUnsavedChanges = true;
  }
  initialGetApi() {
    this.Activecart.getActive().pipe(takeUntil(this.unsubscribe$)).subscribe((x: any) => {
      if (x) {
        this.cartId = x.code;
        this.currentB2bUnitSendToWebtrack = x.currentB2BUnit.uid;
        this.service.getApi(x.code).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
          this.entry = data?.orderType.entry;
          if (data?.currentOrderType) {
            this.orderType = data?.currentOrderType;
          } else {
            this.orderTypeSelected = false;
          }

          this.maxRows = data?.quickOrderMaxRows;
          this.minRows = data?.quickOrderMinRows;
          this.dateFormat = data?.dateFormat.toUpperCase();
          this.initializeForm();
          this.entirePageLoad = true;
          this.initialPageLoadcall = true;
          this.cdr.detectChanges();
        });
      }
    });
  }
  initializeForm() {
    this.myForm = this.fb.group({
      formArray: this.fb.array([])
    });
    for (let i = 0; i < this.minRows; i++) {
      this.addRow();
      this.selectedDates.push(null);
    }
    if (this.orderType == 'EMGY') {
      this.isOrderTypeVORDisableDates = true;
      this.isOrderTypeVOR();
    }
  }
  getFormArrayControls(): AbstractControl[] {
    const formArray = this.myForm.get('formArray') as FormArray;
    return formArray.controls;
  }

  addRow() {
    const formArray = this.myForm.get('formArray') as FormArray;
    if (formArray.length < this.maxRows) {
      formArray.push(this.createRow());

    }
    this.updateAddToCartState();
  }

  createRow(): FormGroup {
    return this.fb.group({
      partNumber: ['', Validators.required],
      desc: [''],
      qty: ['', [Validators.required, this.validateQuantity]],
      date: ['', Validators.required],
      checkbox: [false],
    });
  }

  deleteRow(index: number) {
    const formArray = this.myForm.get('formArray') as FormArray;
    formArray.removeAt(index);
    this.updateAddToCartState();
  }
  //for checking is entered partnumber is valid or not
  checkPartNumberValidity(index: number) {
    const partNumberControl = this.myForm.get(['formArray', index, 'partNumber']);
    if (partNumberControl?.valid) {
      this.service.getProductInfoApi(partNumberControl.value).pipe(takeUntil(this.unsubscribe$)).subscribe((x) => {
        if (x?.['status'] == 'ERROR') {
          this.getProdInfo = x;
          this.disableAddToCart.set(true);
          partNumberControl.setErrors({ partNumberInvalid: true });
          this.cdr.detectChanges();
        }
        else if (x?.['status'] == 'SUCCESS') {
          //this.disableAddToCart.set(false);
          this.productName = x?.['product']['name'];
          const control = this.getFormArrayControls()[index].get('desc');
          control.setValue(this.productName);
          this.getrequesteddeliveryDate(index);
          this.updateAddToCartState();
        }

      });

    } else {
      this.updateAddToCartState();
    }
  }
  //Api call for getting requested delivery dates from backend
  getrequesteddeliveryDate(index) {
    this.service.getReqDelvDateApi(this.cartId).pipe(takeUntil(this.unsubscribe$)).subscribe((date: any) => {
      if (date) {
        this.requestedDeliveryDate = date?.requestedDeliveryDate;
        this.isOrderTypeVORDisableDates = date?.isDeliveryDateDisable;
        if (this.isOrderTypeVORDisableDates) {
          this.isOrderTypeVOR();
        }
        const dateObj = moment(this.requestedDeliveryDate, this.dateFormat?.toUpperCase()).toDate();

        this.bsDate = dateObj;
        const control = this.getFormArrayControls()[index].get('date');
        control.setValue(dateObj);
        this.cdr.detectChanges();
      }
    });
  }

  //to achieve the formatted Date of type by Dateformat

  stringToDate(_date, _format, _delimiter) {
    const formatLowerCase = _format.toLowerCase();
    const formatItems = formatLowerCase.split(_delimiter);
    const dateItems = _date.split(_delimiter);
    const monthIndex = formatItems.indexOf("mm");
    const dayIndex = formatItems.indexOf("dd");
    const yearIndex = formatItems.indexOf("yyyy");
    let month = parseInt(dateItems[monthIndex]);
    month -= 1;
    const formatedDate = new Date(dateItems[yearIndex], month, dateItems[dayIndex]);
    return formatedDate;
  }

  getDateDelimiter(dateFormat) {
    for (let i = 0; i < dateFormat.length; i++) {
      if (isNaN(dateFormat[i]) && dateFormat[i] !== 'd' && dateFormat[i] !== 'm' && dateFormat[i] !== 'y' && dateFormat[i] !== 'D' && dateFormat[i] !== 'M' && dateFormat[i] !== 'Y') {
        return dateFormat[i];
      }
    }
    return null;
  }

  //custom validator for quantity field to make 0 as 1
  validateQuantity(control: AbstractControl): { [key: string]: any } | null {
    const value = control.value;
    if (value !== null && value <= 0) {
      if (control.touched) {
        control.setValue(1);
        return { 'invalidQuantity': false };
      }
      return { 'invalidQuantity': true };
    }
    return null;
  }
  //function for catching the user selected date
  onDateChange(event: Date): void {
    if (event?.toString() === 'Invalid Date') {
      return;
    }
    const selectedDate = event ?? false;
    const control = this.topDateForm.get('topdate');

    if (selectedDate) {
      if (this.isPastDateSelected(selectedDate)) {
        this.isPastDate = true;
      }
      else if (this.isWeekend(selectedDate)) {
        this.isWeekendDate = true;
        this.timeout = setTimeout(() => {
          control.setErrors({ weekend: true });
          this.cdr.detectChanges();
        });
      } else {
        control.setValue(selectedDate, { emitEvent: false });
        this.timeout = setTimeout(() => {
          control.setErrors(null);
          this.cdr.detectChanges();
        });
        this.loopingTheDatesInFormArray(selectedDate, "datePicker");
        this.invalidDate = false;
        this.isPastDate = false;
        this.isWeekendDate = false;
      }
      this.updateAddToCartState();
      this.cdr.detectChanges();
    }
  }
  isPastDateSelected(date: Date): boolean {
    if (!date) {
      return false;
    }

    return date < this.bsDate;
  }

  isWeekend(date: Date | null): boolean {
    if (!date) {
      return false;
    }
    const dayOfWeek = date.getDay();
    return dayOfWeek === 0 || dayOfWeek === 6;
  }

  //function for updating the selected dates
  loopingTheDatesInFormArray(selectedDate, caller, dateDisable?) {
    const formArrayControls = this.getFormArrayControls();
    for (let i = 0; i < formArrayControls.length; i++) {
      const control = formArrayControls[i].get('date');
      this.checkDateDisable(dateDisable, control)
      if (control) {
        try {
          const formGroup = formArrayControls[i] as FormGroup;
          if (this.hasAtLeastOneValue(formGroup)) {
            formGroup.get('date').setValue(selectedDate);
            this.cdr.detectChanges();
            if (caller == "ordertype") {
              this.datesRevised = true;
              this.timeout = setTimeout(() => { this.datesRevised = false; this.cdr.detectChanges(); }, 10000);
            }
          }
        } catch (error) {
          console.error('Error updating date:', error);
        }
      }
    }
    this.cdr.detectChanges();
  }

  checkDateDisable(dateDisable, control) {
    if (dateDisable) {
      control.disable();
    } else {
      control.enable();
    }
  }
  //date change on specific
  get deliveryDateControl(): FormControl {
    return this.topDateForm.get('topdate') as FormControl;
  }
  onBotDateChange(event: Date, index) {
    if (event?.toString() === 'Invalid Date') {
      return;
    }
    const selectedDate = event;
    const formArrayControls = this.getFormArrayControls();
    if (this.isPastDateSelected(selectedDate)) {
      this.isPastDatebot[index] = true;
    }
    else if (this.isWeekend(selectedDate)) {
      this.isWeekendDatebot[index] = true;
      this.timeout = setTimeout(() => {
        formArrayControls[index].get('date').setErrors({ weekend: true });
        this.cdr.detectChanges();
      });
    } else {
      if (this.maxCallStackBugPatchFix) {
        formArrayControls[index].get('date').setValue(selectedDate, { emitEvent: false });
        this.deliveryDateControl.setValue('');
      }
      this.timeout = setTimeout(() => {
        formArrayControls[index].get('date').setErrors(null);
        this.cdr.detectChanges();
      });
      this.invalidDatebot[index] = false;
      this.isPastDatebot[index] = false;
      this.isWeekendDatebot[index] = false;
    }
    this.cdr.detectChanges();
  }
  //function for checking atleast one field is filled per row or not
  private hasAtLeastOneValue(formGroup: FormGroup): boolean {
    try {
      const controls = Object.values(formGroup.controls);
      return controls.some(control => control && control.value);
    } catch (error) {
      console.error('Error checking form values:', error);
      return false;
    }
  }

  //preparing data format for making API Call
  prepareFormData(row: FormGroup): any {
    if (this.orderType == 'EMGY') {
      row.controls['date'].enable();
    }
    const { qty, date, partNumber } = row.value;
    if (qty !== null && qty !== '' && date !== null && date !== '' && partNumber !== null && partNumber !== '') {
      const userSelectedDate = row.controls['date']?.value;//new Date(date);
      const year = userSelectedDate.getFullYear();
      const month = ('0' + (userSelectedDate.getMonth() + 1)).slice(-2);
      const day = ('0' + userSelectedDate.getDate()).slice(-2);
      if (this.orderType == 'EMGY') {
        row.controls['date'].disable();
      }
      return {
        quantity: qty,
        requestedStringDeliveryDate: `${month + '/' + day + '/' + year}`,
        product: {
          code: partNumber
        }
      };
    }
    return null;
  }
  //checking atleast one row is filled or not
  isAtLeastOneRowValid(): boolean {
    const formArray = this.myForm.get('formArray') as FormArray;
    for (let i = 0; i < formArray.length; i++) {
      const rowFormGroup = formArray.at(i) as FormGroup;
      const partNumber = rowFormGroup.get('partNumber')?.value;
      if (partNumber) {
        if (rowFormGroup.invalid) {
          return false;
        }
      }
    }
    return true;
  }

  //function for throwing error if user forgot add quantity or selecting ordertype
  markIndexesAsTouched() {
    const formArray = this.myForm.get('formArray') as FormArray;
    formArray.controls.forEach((control: FormGroup) => {
      let isAnyControlFilled = false;
      Object.values(control.controls).forEach((formControl: FormControl) => {
        if (formControl.value) {
          isAnyControlFilled = true;
        }
      });
      if (isAnyControlFilled) {
        Object.values(control.controls).forEach((formControl: FormControl) => {
          formControl.markAsTouched();
        });
      }
    });
  }
  //function for posting the user enetered data to backEnd
  PostAllData() {
    if (this.orderType == undefined || !(this.isAtLeastOneRowValid())) {
      if (this.orderType == undefined) {
        this.orderTypeNotSelected = true;
      }
      this.markIndexesAsTouched();
      this.dialog.open(KbQuickorderErrPopupComponent, { data: { state: true }, maxWidth: '500px', maxHeight: '335px' });
    }
    else {
      const formArray = this.myForm.get('formArray') as FormArray;
      const formData = formArray.controls.map(control => {
        if (control instanceof FormGroup) {
          return this.prepareFormData(control);
        }
        return null;
      });

      const validFormData = formData.filter(data => data !== null);
      const finalData = { cartEntries: validFormData };

      this.service.postApi(finalData, this.orderType, this.cartId).pipe(takeUntil(this.unsubscribe$)).subscribe((x: any) => {
        const cartData = x?.modifications;
        this.activeCart.reloadActiveCart();
        this.cartTrackingService.trackMultipleAddToCart(finalData, this.cartId, 'QUICK_ORDER', this.currentB2bUnitSendToWebtrack);
        this.dialog.open(AddtocartPopupConfirmationComponent, { data: { cartData } });
        this.resetForm();
      });
    }

  }
  //function for deleting one row
  removeField(index: number) {
    const formArray = this.myForm.get('formArray') as FormArray;
    formArray.removeAt(index);
    this.selectedDates.splice(index, 1);
    if (formArray.length < 3) {
      formArray.push(this.createRow());
    }
    this.updateAddToCartState();
  }
  //function for deleting rows selected checkboxes
  removeSelectedRows() {
    const formArray = this.myForm.get('formArray') as FormArray;
    for (let i = formArray.length - 1; i >= 0; i--) {
      const checkboxControl = formArray.at(i).get('checkbox') as FormControl;
      if (checkboxControl.value) {
        formArray.removeAt(i);
        this.selectedDates.splice(i, 1);
      }
    }
    if (formArray.length < 3) {
      this.initializeForm();
      this.isselectAllcheckBoxes = false;
    }
    this.updateAddToCartState();
    this.cdr.detectChanges();
  }
  //function  for selecting all checkboxes
  selectAllCheckboxes(event: any) {
    const formArray = this.myForm.get('formArray') as FormArray;

    const isTopCheckboxSelected = event.target.checked;
    formArray.controls.forEach((control: FormGroup) => {
      const checkboxControl = control.get('checkbox');
      checkboxControl?.setValue(isTopCheckboxSelected);
      this.cdr.detectChanges();
    });
  }

  resetForm() {
    this.bsDate = this.todayDate;
    this.myForm.reset();
    this.initializeForm();
  }
  //function for intimating backend that ordertype is changed
  onDropdownChange(value: string) {
    this.orderType = value;
    this.toClearDate = null;
    if (this.orderType !== undefined) {
      this.orderTypeNotSelected = false;
      this.orderTypeSelected = true;
      this.service.getOrderType(this.orderType, this.cartId).pipe(takeUntil(this.unsubscribe$)).subscribe((x: any) => {

        this.service.getReqDelvDateApi(this.cartId).pipe(takeUntil(this.unsubscribe$)).subscribe((date: any) => {
          if (date) {
            const dateObj = moment(date?.requestedDeliveryDate, this.dateFormat?.toUpperCase()).toDate();

            this.isOrderTypeVORDisableDates = date?.isDeliveryDateDisable;
            this.isOrderTypeVOR();
            this.bsDate = dateObj;
            this.loopingTheDatesInFormArray(dateObj, "ordertype", this.isOrderTypeVORDisableDates);
          }
        });
      });
    }
  }
  //function for adding new row on user click
  addNewRowIfLastRowClicked(index: number) {
    const formArray = this.myForm.get('formArray') as FormArray;
    const lastRowIndex = formArray.length - 1;
    if (lastRowIndex == index) {
      formArray.push(this.createRow());
    }
  }
  isOrderTypeVOR() {
    const formArrayControls = this.getFormArrayControls();
    const topdateDisable = this.topDateForm.get('topdate');

    for (let i = 0; i < formArrayControls.length; i++) {
      const control = formArrayControls[i].get('date');
      if (control) {
        if (this.isOrderTypeVORDisableDates) {
          topdateDisable.disable();
          control.disable();
          this.cdr.detectChanges();
        } else {
          topdateDisable.enable();
          control.enable();
        }
      }
    }
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
  openAlertbox() {
    if (isPlatformBrowser(this.platformId)) {
      const result = window.confirm(`Reload Site?
    
    Changes you made may not be saved`);
      if (result) {
        // User clicked OK
      } else {
        // User clicked Cancel
      }
    }

  }

  assignLastDate(event) {
    this.lastDate = event.target.value;
  }
  isInvalidDate(event) {
    const test = event.target.value;
    if (test == 'Invalid date') {
      event.target.value = this.lastDate;
      this.invalidDate = true;
    }
  }
  assignLastDateBot(event, i) {
    this.lastDateBot[i] = event.target.value;
  }
  isInvalidDateBot(event, i) {
    const test = event.target.value;
    if (test == 'Invalid date') {
      event.target.value = this.lastDateBot[i];
      this.invalidDatebot[i] = true;
    }
  }

  private updateAddToCartState() {
    const formArray = this.myForm.get('formArray') as FormArray;

    let hasValidRow = false;

    formArray.controls.forEach((group: FormGroup) => {
      const partNumber = group.get('partNumber')?.value;
      const date = group.get('date')?.value;
      const desc = group.get('desc')?.value

      const isFilled = partNumber || date;

      if (isFilled) {
        if (desc) {
          hasValidRow = true;
        }
      }
    });

    this.disableAddToCart.set(!hasValidRow);
  }

}
